/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespContainer_transactions = {
    readonly " $fragmentRefs": FragmentRefs<"PriceDisplay_transactions">;
    readonly " $refType": "PdpRespContainer_transactions";
};
export type PdpRespContainer_transactions$data = PdpRespContainer_transactions;
export type PdpRespContainer_transactions$key = {
    readonly " $data"?: PdpRespContainer_transactions$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespContainer_transactions">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespContainer_transactions",
  "type": "TransactionConnection",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isMultiSku",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "isMultiSku",
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "PriceDisplay_transactions",
          "args": [
            {
              "kind": "Literal",
              "name": "hasSkuId",
              "value": true
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = '021e9b676158886b972512aa460a48c4';
export default node;
